// Auto-generated commands for AiCredits domain — DO NOT EDIT.

import type { CommandDef } from '@voicedojo/api';
import type { UserId } from '../ids.g.js';

export interface RetryAiCreditAccountOpenCommand {
  id: UserId;
}

/** CommandDef descriptor for POST /api/command ($type: 'RetryAiCreditAccountOpenCommand'). */
export const retryAiCreditAccountOpen: CommandDef<RetryAiCreditAccountOpenCommand> = {
  $type: 'RetryAiCreditAccountOpenCommand',
};

